import { render, staticRenderFns } from "./WaterConsumption.global.vue?vue&type=template&id=0b8bccaf&scoped=true&lang=pug&"
import script from "./WaterConsumption.global.vue?vue&type=script&lang=ts&"
export * from "./WaterConsumption.global.vue?vue&type=script&lang=ts&"
import style0 from "./WaterConsumption.global.vue?vue&type=style&index=0&id=0b8bccaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8bccaf",
  null
  
)

export default component.exports